import Navigation from './components/Navigation';
import VideoHero from './components/VideoHero';
import HowItWorksSection from './components/HowItWorksSection';
import BenefitsSection from './components/BenefitsSection';
import ConsultationSection from './components/ConsultationSection';
import ContactSection from './components/ContactSection';
import JsonLd from '../../components/feature/JsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'IronClad Leads',
  url: SITE_URL,
  description:
    'Exclusive Google Ads lead generation for personal injury law firms. One firm per market. Real results.',
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'IronClad Leads',
  alternateName: 'IronClad Marketing Co',
  url: SITE_URL,
  telephone: '+16156029594',
  email: 'Parker.Pierce@IronCladMarketingCo.com',
  address: {
    '@type': 'PostalAddress',
    addressRegion: 'TN',
    addressCountry: 'US',
  },
  description:
    'IronClad Leads provides exclusive Google Ads lead generation for personal injury law firms, ensuring one firm per market for maximum lead quality.',
  serviceType: 'Legal Marketing & Lead Generation',
  areaServed: {
    '@type': 'Country',
    name: 'United States',
  },
  sameAs: [],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'IronClad Leads | Exclusive Personal Injury Lead Generation for Law Firms',
  url: SITE_URL,
  description:
    'IronClad Leads delivers exclusive Google Ads lead generation for personal injury law firms. One firm per market — real results, no shared leads.',
  inLanguage: 'en-US',
  isPartOf: {
    '@type': 'WebSite',
    name: 'IronClad Leads',
    url: SITE_URL,
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'How do you generate exclusive personal injury leads?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We run highly targeted Google Ads campaigns specifically designed for personal injury law firms. Each campaign is exclusive to one firm per market, ensuring you receive every lead generated in your area without any competition from other clients.',
      },
    },
    {
      '@type': 'Question',
      name: 'Do you work with multiple law firms in the same market?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No. IronClad Leads partners with only one personal injury law firm per market. This exclusivity guarantees that all leads generated belong solely to your firm.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I get started with IronClad Leads?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Simply book a free strategy consultation using the form on our website. We will check your market availability and walk you through exactly how the program works.',
      },
    },
  ],
};

export default function HomePage() {
  return (
    <div className="bg-[#0a0a0a]">
      <JsonLd id="website" schema={websiteSchema} />
      <JsonLd id="organization" schema={organizationSchema} />
      <JsonLd id="webpage" schema={webPageSchema} />
      <JsonLd id="faq" schema={faqSchema} />
      <Navigation />
      <VideoHero />
      <HowItWorksSection />
      <BenefitsSection />
      <ConsultationSection />
      <ContactSection />
    </div>
  );
}
